<template>
  <hot-sales-detail :is-edit='true'>
  </hot-sales-detail>
</template>

<script>
import HotSalesDetail from '../components/HotSalesDetail'
export default {
  name: 'EditHotSales',
  components: {
    HotSalesDetail
  }
}
</script>

